import { Controller } from "@hotwired/stimulus"

const SCRIPT_URL = "https://assets.calendly.com/assets/external/widget.js"
const STYLE_URL = "https://assets.calendly.com/assets/external/widget.css"

// Opent de Calendly-popup op een link. De widget wordt pas bij de eerste klik
// geladen, zodat hij het laden van de pagina niet ophoudt. Lukt het laden niet,
// dan volgt de browser gewoon de href.
export default class extends Controller {
  open(event) {
    event.preventDefault()
    loadCalendly()
      .then(() => window.Calendly.initPopupWidget({ url: this.element.href }))
      .catch(() => { window.location.href = this.element.href })
  }
}

let loading = null

function loadCalendly() {
  if (window.Calendly) return Promise.resolve()
  if (loading) return loading

  const style = document.createElement("link")
  style.rel = "stylesheet"
  style.href = STYLE_URL
  document.head.appendChild(style)

  loading = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = SCRIPT_URL
    script.async = true
    script.onload = () => (window.Calendly ? resolve() : reject(new Error("Calendly niet beschikbaar")))
    script.onerror = () => { loading = null; reject(new Error("Calendly niet geladen")) }
    document.head.appendChild(script)
  })
  return loading
}
